import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { APP_CONFIG } from './app/shared/environment.service';

if (environment.production) {
  enableProdMode();
}

/** Ensure each tab has its own unique session */
(function initializeTabSession() {
  const TAB_ID_KEY = 'orgAppTabId';
  let tabId = sessionStorage.getItem(TAB_ID_KEY);

  if (!tabId) {
    // New tab opened
    tabId = crypto.randomUUID(); // generates unique ID
    sessionStorage.setItem(TAB_ID_KEY, tabId);

    // Optional: clear only tab-specific data
    const preservedKeys = ['ACCESS_TOKEN', 'REFRESH_TOKEN'];
    const preserved: Record<string, string> = {};
    preservedKeys.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value) preserved[key] = value;
    });

    // localStorage.clear(); // clear everything
    // Object.entries(preserved).forEach(([key, value]) => localStorage.setItem(key, value));

  } else {
    // Same tab (page refresh)
  }
})();

/**  Fetch dynamic config and bootstrap app */
fetch(`${environment.basePath}/assets/config/config.json`, { cache: 'no-store' })
  .then((response) => response.json())
  .then((config) => {
    if (environment.production) {
      enableProdMode();
    }
    platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });

/**  Browser-specific class for styling */
const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
if (isFirefox) {
  document.body.classList.add('firefox');
} else {
  document.body.classList.add('chrome');
}